import React from 'react'
import { FaWhatsapp } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import styled from 'styled-components'



const Wrapper= styled.section`
.section{
    padding-top: 10%;
    padding-bottom: 10%;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    display: flex;
    gap: 10px;

    img{
      width: 15%;
    }
.icon-div{
    display: flex;
    gap: 10px;
}
p{
  color: #CFCFCF;
}
svg{
    font-size: 22px;
    color: #EC632F;
}
}


@media (min-width: 768px) {
  .section{
    padding-top: 3%;
    padding-bottom: 3%;
    /* justify-content: center; */
    margin: 0  36px;
    display: flex;
    gap: 10px;

    img{
      width: 10%;
    }
.icon-div{
    display: flex;
    gap: 10px;
}
svg{
    font-size: 22px;
}
}

}
@media (min-width: 1200px) {
  .section{
    padding-top: 2%;
    padding-bottom: 1%;
    /* justify-content: center; */
    margin: 0  56px;
    display: flex;
    gap: 10px;

    img{
      width: 4%;
    }
.icon-div{
    display: flex;
    gap: 10px;
}
svg{
    font-size: 30px;
}
}

}


`
function Footer() {
  return (
    <Wrapper>
        <div className='section'>
        <img src="./photos/BackgroundEraser_20240103_194309076.png" alt="photo"/>
        <p>@2024 All Rights Reserved</p>
      <div className='icon-div'>
      <FaWhatsapp />
      <FaFacebook />
      <FaInstagram />

      </div>

        </div>
    </Wrapper>
  )
}

export default Footer
